import * as React from 'react';
import {clsx} from 'clsx';

interface Props {
  type?: 'button' | 'submit' | 'reset' | null | undefined;
  className?: string | null | undefined;
  disabled?: boolean | null | undefined;
  title?: string | null | undefined;
  onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent> | undefined) => void;
  children?: React.ReactNode | null | undefined;
}

export function EvButtonLink(props: Props) {
  return <button type={props.type ?? 'button'}
                 disabled={props.disabled ?? false}
                 title={props.title}
                 className={clsx(
                   props.className,
                   'm-0',
                   'p-0',
                   'border-none',
                   'outline-none',
                   'bg-transparent',
                   'whitespace-nowrap',
                   'text-center',
                   'align-middle',
                   'cursor-pointer',
                   'touch-manipulation',
                   'select-none',
                   'border-transparent',
                   'focus:outline-1',
                   'focus:-outline-offset-2',
                   'focus:outline-black',
                   'focus:no-underline',
                   'active:outline-0',
                   'active:shadow-[inset_0_3px_5px_rgba(0,0,0,0.075)]',
                   'disabled:opacity-65',
                   'disabled:cursor-not-allowed',
                   'disabled:shadow-none',
                 )}
                 onClick={props.onClick}>
    {props.children ?? null}
  </button>;
}
